
import './App.css';
import PortfolioCard from './components/PortfolioCard';


function App() {
  
  return(
    <div className="App">
      <PortfolioCard />
    </div>
    
  );
}


export default App;